import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { CalculateUnitService } from '../services/calculate-unit.service';
import { AddCalculateUnitComponent } from './add-calculate-unit/add-calculate-unit.component';
import { EditCalculateUntComponent } from './edit-calculate-unit/edit-calculate-unit.component';

@Component({
  selector: 'app-calculate-unit',
  templateUrl: './calculate-unit.component.html',
  styleUrls: ['./calculate-unit.component.css']
})
export class CalculateUnitComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: AddCalculateUnitComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditCalculateUntComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: CalculateUnitService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'stt',
        header: 'STT',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'unitName',
        header: 'Tên đơn vị tính',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'symbol',
        header: 'Kí hiệu',
        visible: true,
        sort: false,
        width: 10,
      },
      
      {
        field: 'notes',
        header: 'Ghi chú',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };
    var index= model.pageNo*model.pageSize
    this._service
      .getListCalculateUnit(model)
      .then((res) => {
        if (res) {
          
          this.dataSource = res.data;
          if(this.dataSource){
            this.dataSource.forEach(e => {
              index++
              e.stt=index
            });
          }
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editCalculateUnit(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }
  deleteCalculateUnit(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động đơn vị tính này')
        .then((res) => {
          if (res) {
            // this._service.delete(item.identifier).then(
            //   () => {
            //     this._notifierService.showDeleteDataSuccess();
            //     this.getData();
            //   },
            //   () => {
            //     this._notifierService.showDeleteDataError();
            //   }
            // );
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
    this.pCreate.showPopup();
  }

  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
